import React, { useState, useContext, useEffect } from "react";
import FInputt from "../../components/FInputt/FInputt";
import { useGroup } from "../../hooks/useGroups";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useShareFiado } from "../../hooks/useShareFiado";
import { getIdenticator } from "../../api/directory";
import { useFormik } from "formik";
import { size } from "lodash";
import { useProcessor } from "../../hooks/useProcessor";
import { v4 as uuidv4 } from "uuid";
import FContainer from "../../components/FContainer/FContainer";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FBannerTitle from "../../components/FspendComponents/FBannerSpend/FBannerTitle";
import Swal from "sweetalert2";

const DisperseScreen = ({ param }) => {
  const route = useNavigate();
  const { state } = useLocation();
  const { getMembers, members } = useGroup();
  const [concepto, setConcept] = useState("");

  const [keys, setKeys] = useState([]);
  const {
    setFiadoShareObject,
    object,
    setAmountToMember,
    convertToProcessorData,
    processorObject,
    createProcessorObject,
  } = useShareFiado();
  const [idempotencyKey, setIdempotencyKey] = useState(null);
  const { processPayment } = useProcessor();
  const { setAlert } = useContext(AuthContext);

  useEffect(() => {
    const data = async () => {
      setFiadoShareObject(state.members);
    };
    data();
    setKeys(Object.keys(object));
    setIdempotencyKey(uuidv4());
  }, []);

  const nextScreen = async (data, idempotencyKey) => {

    let response = await processPayment(data, idempotencyKey);
    if (response?.data?.code == "PROCESS_OK") {

      Swal.fire({
        showCloseButton: true,
        title: 'Éxito',
        text: 'Pediste el dinero',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        // iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          route("/")
        } else {
          route("/")
        }
      }, function(dismiss) {
        if (dismiss === 'cancel') {
          route("/")
        }
      });

    }
  }

  const formikDisperse = useFormik({
    initialValues: {},
    onSubmit: async (values) => {
      for (const i in values) {
        setAmountToMember(i, values[i]);
      }
      let _processorObject = createProcessorObject("484", "484");
      
 

      if (state.screen == "ApplyGroupScreen") {
        let _products = _processorObject.products.filter((object)=> object.id != "FIADO_FUNDS_AVAILABLE_MXN"  && object.amount > 0 ).map((product) => {
          return {
            id: "REQUEST_FIADO_SHARE_MXN",
            amount: product.amount,
            requestDirectoryId: product.beneficiaryDirectoryId,
            requestTypeOfDirectoryId: "USER",
            concept: concepto,
          }
        })

        let _data = {
          originCurrencyId: _processorObject.originCurrencyId,
          destinationCurrencyId: _processorObject.destinationCurrencyId,
          exchangeRateId: null,
          products: _products
        }

        nextScreen(_data, idempotencyKey);

      }
      else {

        //Remove group member without valid amount;
        let paymentMethod =  {id:"FIADO_FUNDS_AVAILABLE_MXN"}
        let products = _processorObject.products.filter((object)=> object.id != "FIADO_FUNDS_AVAILABLE_MXN"  && object.amount > 0 )
 
        if(products.length <= 0){
          return Swal.fire({
            title: 'Atención',
            text: "Necesitas indicar un monto para al menos un miembro del grupo.",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            // iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          })
        }

        if(concepto == ''){
          return Swal.fire({
            title: 'Atención',
            text: "Indica el concepto de la transacción.",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            // iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          })
        }

        products.push(paymentMethod)

          //Add concept to users to disperse
          _processorObject.products.filter((object)=> object.id != "FIADO_FUNDS_AVAILABLE_MXN"  && object.amount > 0 ).map((product) => {
          product.concept = concepto
          })
          _processorObject.products = products
          console.log(_processorObject)

          sendPay(_processorObject);



      }
    },
    validate: (_processorObject) => {
      //   const errors = {};
      //   if (!values.name) errors.name = "Campo Requerido";
      //   if (!values.description) errors.description = "Campo Requerido";
      //   return errors;
    },
  });

  const sendPay = async (Object) => {
    if (true == true && idempotencyKey) {
      let response = await processPayment(Object, idempotencyKey);
      if (response?.data?.code == "PROCESS_OK") {
        Swal.fire({
          title: 'Éxito',
          text: "La transferencia se ha realizado exitosamente.",
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          // iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        }).then((result) => {
          if (result.isConfirmed) {
            route("/");
          } else {
            route("/");
          }
        })
      }
    }
  };

  return (
    <>
      <div className="border-0 grid place-items-center">
        <div className="border-0 grid grid-cols-1 xss:w-[450px] text-[5vw] smm:text-[25px] place-items-center">
          <div className="border-0 col-span-1 grid grid-rows-1 text-center py-3 sm:py-7">
            <div className="border-0 row-span-1 font-bold text-Secondary">
              Agrega el monto que deseas {state.screen == "ApplyGroupScreen" ? "solicitar" : "compartir"} a cada integrante
            </div>
          </div>
        </div>
      </div>

      <FContainer>
        {keys.length > 0
          ? keys.map((item, index) => (
            <div className="w-full" key={index}>
              <FInputText
                type="CurrencyInput"
                title={object[item].preferredName}
                placeholder={"¿Cuánto?"}
                onChange={(value) => {
                  formikDisperse.setFieldValue(item, value);
                }}
              />
            </div>
          ))
          : null}
          <FInputText title={"Concepto"} placeholder={"Concepto"} value={concepto} onChange={(value) => {
            setConcept(value)
          }} />
        <Fbutton value="Continuar" onClick={formikDisperse.handleSubmit} />
      </FContainer>
    </>
  );
};

export default DisperseScreen;
